import React, { useState } from "react";
import { Modal, Button, reactBootstrap } from "react-bootstrap";
import TreesToHypertext from "./TreesToHypertext";

function ModalGetTrees(props) {
  const {
    baseUrl,
    formik,
    handleClose,
    notPastWeekObs,
    pastWeekDate,
    show,
    setShowModalGetTrees,
  } = props;

  return (
    <div>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton onClick={() => setShowModalGetTrees(false)}>
          <Modal.Title>
            {formik.values.lastName}'s Next Observations
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Trees assigned to observer {formik.values.lastName} that have not
            been
            <br />
            observed in the past 2 days (before {pastWeekDate}):
            <br></br>
            <br></br>
            <TreesToHypertext
              notPastWeekObs={notPastWeekObs}
              formik={formik}
              baseUrl={baseUrl}
              handleClose={() => setShowModalGetTrees(false)}
            />
            <br></br>
            Please make sure the correct collection(Genus) assigned to observer{" "}
            {formik.values.lastName} is selected.
            <br></br>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowModalGetTrees(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
export default ModalGetTrees;
